import { useFanTokenOfferings } from '@capsicum/socios-core';
import { useMemo } from 'react';

export const useFanTokenOfferingSection = ({ partnerId }: { partnerId?: string } = {}) => {
	const {
		data: fanTokenOfferings,
		isLoading: isFanTokenOfferingsLoading,
		isRefetching: isRefetchingFanTokenOfferings,
		refetch
	} = useFanTokenOfferings({
		...(partnerId && { 'partnerIds[]': [partnerId] })
	});

	const filteredFanTokenOfferings = useMemo(() => {
		return fanTokenOfferings?.filter(fanTokenOffering => fanTokenOffering.claimRequest?.status !== 'processed');
	}, [fanTokenOfferings]);

	return {
		filteredFanTokenOfferings,
		isFanTokenOfferingsLoading,
		isRefetchingFanTokenOfferings,
		refetch
	};
};
